import {Identify} from '@amplitude/analytics-core';
import {AMPLITUDE_API_KEY} from "../../config";

export const APPSFLYER_ID_LOCAL_STORAGE_KEY = 'appsflyerId';

let amplitudeAnalytics = null;

const loadAmplitudeAnalytics = async () => {
  if (!amplitudeAnalytics) {
    amplitudeAnalytics = await import('@amplitude/analytics-browser');
  }
  return amplitudeAnalytics;
};

class AmplitudeAnalytics {
  apiKey;
  isInitialized = false;

  constructor(apiKey) {
    this.apiKey = apiKey;
  }

  async initialize() {
    if (!this.isInitialized) {
      await loadAmplitudeAnalytics();
      amplitudeAnalytics.init(this.apiKey, {
        defaultTracking: {
          formInteractions: false,
          pageViews: false,
          sessions: true,
        },
      });

      this.setAppsflyerId(
        localStorage.getItem(APPSFLYER_ID_LOCAL_STORAGE_KEY) ?? '',
      );
      this.isInitialized = true;
    }
  }

  async setAppsflyerId(id) {
    if (!id) return;

    await this.initialize();
    const identity = new Identify().set('appsflyer_id', id);
    amplitudeAnalytics.identify(identity);
  }

  async setUser(id) {
    await this.initialize();
    amplitudeAnalytics.setUserId(id);
    this.setAppsflyerId(
      localStorage.getItem(APPSFLYER_ID_LOCAL_STORAGE_KEY) ?? '',
    );
  }

  async track(name, data) {
    await this.initialize();
    const packageName = localStorage.getItem('packageName');
    amplitudeAnalytics.logEvent(name, { ...data, ...(packageName && {package_name: packageName })});
  }

  async reset() {
    await this.initialize();
    amplitudeAnalytics.reset();
  }
}

export function hostType() {
  const packageName = localStorage.getItem('packageName');
  if (packageName) return 'mobile app';
  if (window.innerWidth < 768) return 'mobile web';
  return 'desktop';
}

export function screenName() {
  return window.location.pathname;
}

export default new AmplitudeAnalytics(AMPLITUDE_API_KEY);
